import React, { Fragment } from "react";
import "./topheader.css";

const TopHeader = () => {
  return (
    <Fragment>
      <div className="top_nav_body">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 top_nav_about">
              <p className="call_us">تماس با ما : 091275414123</p>
              <p className="mail_us"> info@aroosaki.com : ایمیل </p>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 top_nav_icons">
              <i class="uil uil-twitter"></i>
              <i class="uil uil-facebook"></i>
              <i class="uil uil-instagram"></i>
              <i class="uil uil-whatsapp"></i>
              <i class="uil uil-youtube"></i>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TopHeader;
